import { ResponsiveLine } from '@nivo/line';

interface ConsumptionGraphProps {
  data: {
    id: string;
    data: {
      x: string;
      y: number;
    }[];
  }[];
}

export function ConsumptionGraph({ data }: ConsumptionGraphProps) {
  return (
    <ResponsiveLine
      data={data}
      margin={{ top: 10, right: 0, bottom: 0, left: 0 }}
      theme={{
        axis: {
          domain: {
            line: {
              strokeWidth: 0,
            },
          },
          ticks: {
            line: {
              strokeWidth: 0,
            },
            text: {
              fill: 'rgba(0, 0, 0, 0)',
            },
          },
        },
      }}
      yScale={{ type: 'linear', min: 'auto', max: 'auto' }}
      axisBottom={{ legend: '' }}
      axisLeft={{ legend: '' }}
      enableGridX={false}
      enableGridY={false}
      enablePoints={false}
      animate={true}
      enableArea={true}
      areaOpacity={0.2}
      enableCrosshair={false}
      useMesh={false}
      curve="basis"
    />
  );
}
